import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui';
export const Footer = () => {
  return <footer className="bg-[#060810] pt-24 pb-8 border-t border-gold/20" data-id="element-48">
      <div className="container mx-auto px-6" data-id="element-49">
        {/* Footer CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-2xl mx-auto mb-24" data-id="element-50">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-51">
            Ești gata să faci primul pas?
          </h2>
          <p className="font-sans text-textSub text-xl mb-10" data-id="element-52">
            Locurile la NLP Practitioner sunt limitate. Dacă simți că e momentul
            tău, nu mai aștepta să fie mai bine. Momentul e acum.
          </p>
          <Button data-id="element-53">Scrie-mi pe WhatsApp pentru detalii!</Button>
        </motion.div>
        <div className="w-full h-px bg-gold/10 mb-8" data-id="element-54" />
        {/* Footer Links */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm font-sans text-textSub" data-id="element-55">
          <p data-id="element-56">
            © {new Date().getFullYear()} Marius Cernea. Toate drepturile
            rezervate.
          </p>
          <div className="flex gap-6" data-id="element-57">
            <a href="#" className="hover:text-gold transition-colors" data-id="element-58">
              Termeni și Condiții
            </a>
            <a href="#" className="hover:text-gold transition-colors" data-id="element-59">
              Politică de Confidențialitate
            </a>
            <a href="#" className="hover:text-gold transition-colors" data-id="element-60">
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>;
};